import { IndexHooks } from "./Hooks";

import HeaderReport from "../../header/report";
import libForm from "../../../util/libForm";
import SelectInputSimple from "../../inputs/select/simple";
import SelectTipoCliente from "../../inputs/select/SelectTipoCliente";
import RadioInput from "../../inputs/radio";
import TextInput from "../../inputs/text";
import DatePickerInputV1 from "../../inputs/date-time/v1";
import { BtnSearch } from "../../button/button-search";
import { useEffect, useState } from "react";
import HeaderFilter from "../../header/filter";
import { Switch } from "@mui/material";
import Loading from "../../loading";

const FilterReportDateItens = ({ options, handleSubmitModalFilter, reloadFilter, renderParamValue }) => {
	const parameters = options.parametersFilter;
	const parametersDate = options.parametersDate;
	const [loading, setLoading] = useState(true);

	// const hasParameters = Array.isArray(parameters) && parameters.length > 0;

	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,

		hasParam,
		setFocus,
		setValue,
		control,
		Controller,
	} = IndexHooks({ options, handleSubmitModalFilter });

	useEffect(() => {
		try {
			setLoading(true);
			reloadFilter &&
				Object.keys(reloadFilter).forEach((field) => {
					setValue(field, reloadFilter[field]);
				});
		} catch (error) {
		} finally {
			setLoading(false);
		}
	}, []);

	return (
		<div className="">
			<form onSubmit={handleSubmit(handleOnSubmit)} action="submit">
				<HeaderFilter title={options.title} />
				{loading ? (
					<div className="h-80">
						<Loading mensagem={"Carregando"} />
					</div>
				) : (
					<>
						{options.hasSaleType && (
							<div className="border-bottom w-full ">
								<SelectInputSimple
									label="Tipo de venda"
									id="salesType"
									register={register}
									control={control}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									autoFocus={true}
								/>
							</div>
						)}
						{options.hasClientType && (
							<div className="border-bottom w-full ">
								<SelectTipoCliente id="clientType" control={control} />
							</div>
						)}
						{options.hasDate !== false && (
							<div>
								<div className="row mt-2">
									{parametersDate.map((item, index) => (
										<RadioInput
											key={index}
											item={item}
											id={"paramDate"}
											register={register}
											control={control}
										/>
									))}
								</div>
								{/* <div className="flex items-center justify-between gap-4 mt-2 border-bottom bg-red-400"> */}
								<div className="flex flex-col md:flex-row md:justify-between gap-4 mt-2">
									<div className="w-full md:w-1/2">
										<DatePickerInputV1
											label="Data Inicial"
											id="dtIni"
											register={register}
											control={control}
											errors={errors}
											showTime={true}
											onKeyDown={libForm.EnterTab}
										/>
									</div>

									<div className="w-full md:w-1/2">
										<DatePickerInputV1
											label="Data Final"
											id="dtFim"
											register={register}
											control={control}
											errors={errors}
											showTime={true}
											onKeyDown={libForm.EnterTab}
										/>
									</div>
								</div>
							</div>
						)}

						<div className="border-bottom">
							{hasParam && (
								<div className="row mt-2">
									{parameters.map((item, index) => (
										<RadioInput
											key={index}
											item={item}
											id={"param"}
											register={register}
											control={control}
										/>
									))}
								</div>
							)}
							{options.hasActive && (
								<div className="flex-wrap mt-3">
									<div className="check-input d-flex align-items-center justify-content-end">
										<Controller
											name="active"
											control={control}
											defaultValue={true}
											render={({ field }) => {
												let currentLabel = "Ativo";
												if (options.activeLabel) {
													currentLabel = field.value ? options.activeLabel.true : options.activeLabel.false;
												}
												
												return (
													<>
														<Switch
															checked={field.value}
															onChange={(e) => field.onChange(e.target.checked)}
															inputProps={{
																"aria-label": "Ativos",
															}}
														/>
														<label htmlFor="active">{currentLabel}</label>
														{/* <label htmlFor="active">{`Ativo ${field.value ? "SIM" : "NAO"} `}</label> */}
													</>
												);
											}}
										/>{" "}
										{errors.active && <p className="errors">{errors.active.message}</p>}
									</div>
								</div>
							)}
							{hasParam && (
								<>
									{renderParamValue ? (
										renderParamValue({ paramSelected, register, control, errors })
									) : (
										<TextInput
											label={paramSelected.label}
											id="paramValue"
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											autoFocus={true}
											className={"mt-2"}
										/>
									)}
								</>
							)}
						</div>
					</>
				)}
				<footer>
					<div></div>
					<BtnSearch isSubmitting={isSubmitting} />
				</footer>
			</form>
		</div>
	);
};

export default FilterReportDateItens;
